import { render } from "./OnboardingProfileMissingModal.vue?vue&type=template&id=407d691e&scoped=true"
import script from "./OnboardingProfileMissingModal.vue?vue&type=script&lang=js"
export * from "./OnboardingProfileMissingModal.vue?vue&type=script&lang=js"

import "./OnboardingProfileMissingModal.vue?vue&type=style&index=0&id=407d691e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407d691e"]])

export default __exports__